const Footer: React.FC = () => (
  <footer>
    <div className="wrap">
      <span>© {new Date().getFullYear()} Jacob Wu-Chen</span>
    </div>
  </footer>
);

export default Footer;
